<template>
  <b-container fluid>
    <iq-card>
        <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('beneficiary_management.payment_dashboard') }}</h4>
        </template>
        <template v-slot:body>
            <b-row>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('globalTrans.organization')"
                    label-for="org_id"
                    >
                        <b-form-select
                        plain
                        v-model="search.org_id"
                        :options="getOrgList"
                        id="org_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('educational_management.fiscal_year')"
                    label-for="fiscal_year"
                    >
                    <b-form-select
                        plain
                        v-model="search.fiscal_year"
                        :options="fiscalYear"
                        id="fiscal_year"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('social_service.month')"
                    label-for="month"
                    >
                        <b-form-select
                        plain
                        v-model="search.month"
                        :options="monthList"
                        id="month"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('grant_budget_management.service_type')"
                    label-for="service_type"
                    >
                    <b-form-select
                        plain
                        v-model="search.service_type_id"
                        :options="serviceTypeList"
                        id="service_type"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('grant_budget_management.service_name')"
                    label-for="service_id"
                    >
                        <b-form-select
                        plain
                        v-model="search.service_id"
                        :options="serviceName"
                        id="service_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" xs="12">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('beneficiary_management.bank_name')"
                    label-for="bank_id"
                    >
                        <b-form-select
                        plain
                        v-model="search.bank_id"
                        :options="bankList"
                        id="bank_id"
                        >
                        <template v-slot:first>
                        <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col class="text-right">
                <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
        </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('beneficiary_management.total_beneficiary_account')}}
                        </h5>
                        <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(total_account ? total_account : '0') }}</h2>
                    </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('beneficiary_management.approved_go')}}
                        </h5>
                        <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(total_go ? total_go : '0') }}</h2>
                    </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('beneficiary_management.online_payment')}}
                        </h5>
                        <b-spinner v-if="unitLoad" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(total_payment ? total_payment : '0') }}</h2>
                    </div>
                </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import RestApi, { grantAllowanceServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { paymentDashboardApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
    mixins: [ModalBaseMasterList],
    components: {
    },
    data () {
        return {
            search: {
                fiscal_year: 0,
                month: 0,
                service_type_id: 0,
                service_id: 0,
                org_id: 0,
                bank_id: 0
            },
            total_account: 0,
            total_go: 0,
            total_payment: 0,
            serviceName: [],
            bankList: [],
            unitLoad: false
        }
    },
    computed: {
        formTitle () {
            return (this.editItemId === 0) ? this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.entry') : this.$t('social_service.dashbboard') + ' ' + this.$t('globalTrans.modify')
        },
        getOrgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        serviceTypeList () {
            const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        fiscalYear: function () {
            const fiscalyear = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
            return fiscalyear.map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.text_en, text: item.text_bn }
                } else {
                    return { value: item.text_en, text: item.text_en }
                }
            })
        },
        monthList () {
            const objectData = this.$store.state.commonObj.monthList
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
                } else {
                return { value: obj.value, text: obj.text_en }
                }
            })
        }
    },
    watch: {
        'search.service_type_id': function (newVal) {
            this.serviceName = this.getServiceName()
        },
        '$i18n.locale': function (newValue) {
            this.serviceName = this.getServiceName()
            this.fetchBankBranchList()
        }
    },
    created () {
        this.fetchBankBranchList()
        this.loadData()
    },
    methods: {
        async fetchBankBranchList () {
            this.bankList = await RestApi.getData(commonServiceBaseUrl + '/common/bank-list-all')
            this.bankList = this.bankList.map(obj => ({
                value: obj.value,
                text: this.$i18n.locale === 'bn' ? obj.text_bn : obj.text_en,
                text_en: obj.text_en,
                text_bn: obj.text_bn
            }))
        },
        getServiceName () {
            const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === this.search.service_type_id && item.has_public_form === 1)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        searchData () {
            this.loadData()
        },
        loadData () {
            this.unitLoad = true
            const params = Object.assign({}, this.search)
            RestApi.getData(grantAllowanceServiceBaseUrl, paymentDashboardApi, params).then(response => {
                if (response.success) {
                    this.total_account = response.total
                    this.total_go = response.total_go
                    this.total_payment = response.total_amount
                    this.unitLoad = false
                }
            })
        }
    }
}
</script>
